import { apiService } from "./apiService";

export const getAiPromptsOverview = async () =>
  apiService.request("/super-admin/ai-prompts", { method: "GET" });

export const getAiPromptDetail = async (promptKey) =>
  apiService.request(`/super-admin/ai-prompts/${encodeURIComponent(promptKey)}`, {
    method: "GET",
  });

export const saveAiPromptVersion = async (promptKey, text) =>
  apiService.request(
    `/super-admin/ai-prompts/${encodeURIComponent(promptKey)}/versions`,
    {
      method: "POST",
      body: JSON.stringify({ text }),
    },
  );

export const getAiPromptVersions = async (promptKey) =>
  apiService.request(
    `/super-admin/ai-prompts/${encodeURIComponent(promptKey)}/versions`,
    { method: "GET" },
  );

export const previewAiPromptSync = async (promptKey, tenantIds) =>
  apiService.request(
    `/super-admin/ai-prompts/${encodeURIComponent(promptKey)}/sync/preview`,
    {
      method: "POST",
      body: JSON.stringify({ tenantIds }),
    },
  );

export const syncAiPrompt = async (promptKey, tenantIds) =>
  apiService.request(
    `/super-admin/ai-prompts/${encodeURIComponent(promptKey)}/sync`,
    {
      method: "POST",
      body: JSON.stringify({ tenantIds }),
    },
  );

export const getAiPromptChangeLog = async ({
  promptKey = null,
  page = 1,
  pageSize = 25,
} = {}) => {
  const params = new URLSearchParams();
  if (promptKey) params.set("promptKey", promptKey);
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  const qs = params.toString();
  return apiService.request(`/super-admin/ai-prompts/change-log?${qs}`, {
    method: "GET",
  });
};

export const getAiPromptChangeLogEntry = async (id) =>
  apiService.request(`/super-admin/ai-prompts/change-log/${id}`, {
    method: "GET",
  });

export const revertAiPromptChangeLog = async (id) =>
  apiService.request(`/super-admin/ai-prompts/change-log/${id}/revert`, {
    method: "POST",
  });

export const getTenantAiPromptStatuses = async (tenantId) =>
  apiService.request(`/super-admin/ai-prompts/tenants/${tenantId}/statuses`, {
    method: "GET",
  });
